import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M9 17.5467C9 16.9929 8.54972 16.5515 8.00297 16.4733C4.60923 15.988 2 13.0619 2 9.52472C2 5.64811 5.13401 2.50549 9 2.50549C12.866 2.50549 16 5.64811 16 9.52472C16 10.39 15.8439 11.2187 15.5583 11.9841C15.2993 12.6782 15.7588 13.5357 16.4979 13.5357C16.845 13.5357 17.1659 13.3401 17.3004 13.0193C17.751 11.9444 18 10.7637 18 9.52472C18 4.54051 13.9706 0.5 9 0.5C4.02944 0.5 0 4.54051 0 9.52472C0 14.1706 3.50088 17.9965 8.0016 18.4945C8.55055 18.5553 9 18.1005 9 17.5467Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M9 4.51099C9.55229 4.51099 10 4.95993 10 5.51374V9.02335H13C13.5523 9.02335 14 9.4723 14 10.0261C14 10.5799 13.5523 11.0288 13 11.0288H9C8.44771 11.0288 8 10.5799 8 10.0261V5.51374C8 4.95993 8.44771 4.51099 9 4.51099Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M12 15.5347C11.4477 15.5347 11 15.9837 11 16.5375C11 17.0913 11.4477 17.5402 12 17.5402H15.9999C16.5522 17.5402 16.9999 17.0913 16.9999 16.5375C16.9999 15.9837 16.5522 15.5347 15.9999 15.5347H12Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}